module.exports = __webpack_public_path__ + "static/media/thumbnail_insorb-for-use@2x.fceebb28.jpg";